import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import Wholesale from '@digital-retail/wholesale';
import { cx } from 'cvb';
import { withApplicationContext } from '../../utils/ApplicationContext';
import getLabels from './WholesaleBanner.labels';
import styles from './WholesaleBanner.style';

const WholesaleBanner = ({ appCtx, inputVal, onClick, quantityToBuyValue, quantityToBuyOperator, staticHeight }) => {
  const handleOnClick = (quantityToAdd) => {
    onClick({ quantity: quantityToAdd });
  };

  const { deviceType } = appCtx;
  const labels = getLabels(appCtx);

  const operatorClass = {
    '=': 'equal',
    '>=': 'greaterOrEqual',
  }[quantityToBuyOperator];

  return (
    <div className={cx('wholesale-container', operatorClass, staticHeight && 'static-height')}>
      <style jsx>{styles}</style>
      <Wholesale.Banner
        labels={labels}
        quantityInCart={inputVal}
        onClickOnAddProducts={handleOnClick}
        quantityToBuyValue={quantityToBuyValue}
        quantityToBuyOperator={quantityToBuyOperator}
        analytics={{}}
        showActivePromotionsBanner
        addProductsOnClickOnText
        deviceType={deviceType}
      />
    </div>
  );
};

WholesaleBanner.defaultProps = {
  staticHeight: false,
};

WholesaleBanner.propTypes = {
  appCtx: PropTypes.object.isRequired,
  inputVal: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  quantityToBuyValue: PropTypes.number.isRequired,
  quantityToBuyOperator: PropTypes.string.isRequired,
  staticHeight: PropTypes.bool,
};

export { WholesaleBanner };
export default withApplicationContext(WholesaleBanner);
